import React, { useState } from 'react';
import './Newsletter.css';

const Newsletter = () => {
  const [formData, setFormData] = useState({
    EMAIL: '',
    FNAME: '',
    LNAME: ''
  });
  const [status, setStatus] = useState(''); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      // Submit to Mailchimp
      const params = new URLSearchParams();
      params.append('EMAIL', formData.EMAIL);
      params.append('FNAME', formData.FNAME);
      params.append('LNAME', formData.LNAME);
      params.append('u', '813addac10089ecd3f9f3de6d');
      params.append('id', 'dcb3f18705');

      const response = await fetch(
        'https://ebta.us1.list-manage.com/subscribe/post?u=813addac10089ecd3f9f3de6d&id=dcb3f18705&f_id=00da14e5f0',
        {
          method: 'POST',
          body: params,
          mode: 'no-cors'
        }
      );

      // Reset form
      setFormData({
        EMAIL: '',
        FNAME: '',
        LNAME: ''
      });
      setStatus('success');
      setMessage('Thank you for subscribing!');

      // Clear message after 5 seconds
      setTimeout(() => {
        setStatus('');
        setMessage('');
      }, 5000);
    } catch (error) {
      setStatus('error');
      setMessage('An error occurred. Please try again.');
      console.error('Newsletter subscription error:', error);
    }
  };

  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-wrapper">
          <div className="newsletter-content">
            <h2>Subscribe to Our Newsletter</h2>
            <p>Stay updated with the latest news, events, and research from the European Brief Therapy Association.</p>

            <form onSubmit={handleSubmit} className="newsletter-form">
              <div className="form-group">
                <input
                  type="email"
                  name="EMAIL"
                  value={formData.EMAIL}
                  onChange={handleInputChange}
                  placeholder="Your email address *"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="FNAME"
                    value={formData.FNAME}
                    onChange={handleInputChange}
                    placeholder="First Name"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="LNAME"
                    value={formData.LNAME}
                    onChange={handleInputChange}
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary newsletter-btn"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>

            {message && (
              <div className={`newsletter-message ${status}`}>
                {message}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
